import src from "IMAGE";
export default { src, width: 1920, height: 1080, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAPElEQVR42nWJSQ7AIAzE8v/3NkvbTCAaIQ5I+GTZMi7Itp+cIzMf0rIGAFXrpMTM3L2jVNVLIqIT9QNqAvLGdeig8hHVAAAAAElFTkSuQmCC"};
